// third-party
import { FormattedMessage } from 'react-intl';

// assets
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import CancelPresentationOutlinedIcon from '@mui/icons-material/CancelPresentationOutlined';
import MoneyOutlinedIcon from '@mui/icons-material/MoneyOutlined';
import PaymentsOutlinedIcon from '@mui/icons-material/PaymentsOutlined';
// type

// icons
const icons = { AccountBalanceIcon, AccountBalanceWalletOutlinedIcon, CancelPresentationOutlinedIcon, MoneyOutlinedIcon, PaymentsOutlinedIcon };

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const account = {
  id: 'account',
  title: <FormattedMessage id="Account" />,
  icon: icons.AccountBalanceIcon,
  type: 'group',
  children: [
    {
      id: 'account/patient-wallet',
      title: <FormattedMessage id="Patient Wallet" />,
      type: 'item',
      url: '/account/patient-wallet',
      icon: icons.AccountBalanceWalletOutlinedIcon,
      visible: (roles, isAdmin) => roles.includes('account_manager') || roles.includes('receptionist') || isAdmin
    },
    {
      id: 'account/payment-requests',
      title: <FormattedMessage id="Payment Requests" />,
      type: 'item',
      url: '/account/payment-requests',
      icon: icons.PaymentsOutlinedIcon,
      visible: (roles, isAdmin) => roles.includes('account_manager') || isAdmin
    },
    {
      id: 'account/daily-cash-collection',
      title: <FormattedMessage id="Daily Cash Collection" />,
      type: 'item',
      url: '/account/daily-cash-collection',
      icon: icons.AccountBalanceIcon,
      visible: (roles, isAdmin) => roles.includes('account_manager') || roles.includes('pharmacy_biller') || roles.includes('lab_billing') || isAdmin
    },
    {
      id: 'account/total-collection',
      title: <FormattedMessage id="Total Collection" />,
      type: 'item',
      url: '/account/total-collection',
      icon: icons.MoneyOutlinedIcon,
      visible: (roles, isAdmin) => roles.includes('account_manager') || roles.includes('receptionist') || isAdmin
    },
    {
      id: 'account/cancellation-ledger',
      title: <FormattedMessage id="Cancellation Ledger" />,
      type: 'item',
      url: '/account/cancellation-ledger',
      icon: icons.CancelPresentationOutlinedIcon,
      visible: (roles, isAdmin) => roles.includes('account_manager') || roles.includes('receptionist') || isAdmin
    }
  ]
};

export default account;
